import { Component, OnInit } from '@angular/core';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

/**
 * Dedicated MSAL v5 redirect-bridge page for popup/iframe auth (COOP-safe).
 * Must not run MsalGuard / MsalInterceptor / handleRedirectObservable.
 */
@Component({
  selector: 'app-msal-redirect',
  template: '<p>Completing authentication...</p>',
  standalone: false
})
export class MsalRedirectComponent implements OnInit {
  ngOnInit(): void {
    broadcastResponseToMainFrame().catch((error: Error) => {
      console.error('Error broadcasting MSAL response to main frame:', error);
    });
  }
}
